var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-autocomplete',{attrs:{"label":"Selecione o galpão","items":_vm.depots,"rules":_vm.required,"prepend-icon":"mdi-star","item-text":"name","item-value":"id","loading":_vm.loading},model:{value:(_vm.order.modality_id),callback:function ($$v) {_vm.$set(_vm.order, "modality_id", $$v)},expression:"order.modality_id"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }